import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addPendingInstallationRequest = {};
var _addPendingInstallationResponse = {};
var _completeInstallationRequest = {};
var _completeInstallationResponse = {};
var _deleteInstallationRequest = {};
var _deleteInstallationResponse = {};
var _getPendingInstallationsRequest = {};
var _getPendingInstallationsResponse = {};
function resolveComWixpressDevcenterPendingappsPendingInstallationsUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/pending-installations',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/pending-installations',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/pending-installations',
                destPath: '/api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/pending-installations',
                destPath: '/api',
            },
            {
                srcPath: '/_api/pending-installations',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/pending-installations',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/pending-installations',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/pending-installations',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/pending-installations',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Add a new pending installation */
export function add(payload) {
    var _a = serializer(_addPendingInstallationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addPendingInstallationResponse, {}).fromJSON;
    function __add(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.pendingapps.v1.pending_installation',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.pendingapps.PendingInstallations.add',
            url: resolveComWixpressDevcenterPendingappsPendingInstallationsUrl({
                protoPath: '/api/v1/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __add.fromReq = fromReq;
    __add.__isAmbassador = true;
    return __add;
}
/** complete a pending installation */
export function completeInstallation(payload) {
    var _a = serializer(_completeInstallationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_completeInstallationResponse, {}).fromJSON;
    function __completeInstallation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.pendingapps.v1.pending_installation',
            method: 'POST',
            methodFqn: 'com.wixpress.devcenter.pendingapps.PendingInstallations.completeInstallation',
            url: resolveComWixpressDevcenterPendingappsPendingInstallationsUrl({
                protoPath: '/api/v1/complete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __completeInstallation.fromReq = fromReq;
    __completeInstallation.__isAmbassador = true;
    return __completeInstallation;
}
/** get all pending installations for current metaSiteId */
export function getPendingInstallations(payload) {
    var _a = serializer(_getPendingInstallationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPendingInstallationsResponse, {}).fromJSON;
    function __getPendingInstallations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.pendingapps.v1.pending_installation',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.pendingapps.PendingInstallations.getPendingInstallations',
            url: resolveComWixpressDevcenterPendingappsPendingInstallationsUrl({
                protoPath: '/api/v1/get',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPendingInstallations.fromReq = fromReq;
    __getPendingInstallations.__isAmbassador = true;
    return __getPendingInstallations;
}
/** delete a pending installation, regardless of the pending reasons. */
export function deleteInstallation(payload) {
    var _a = serializer(_deleteInstallationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteInstallationResponse, {}).fromJSON;
    function __deleteInstallation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.pendingapps.v1.pending_installation',
            method: 'DELETE',
            methodFqn: 'com.wixpress.devcenter.pendingapps.PendingInstallations.DeleteInstallation',
            url: resolveComWixpressDevcenterPendingappsPendingInstallationsUrl({
                protoPath: '/api/v1/pending-installation',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteInstallation.fromReq = fromReq;
    __deleteInstallation.__isAmbassador = true;
    return __deleteInstallation;
}
//# sourceMappingURL=http.impl.js.map